import { STYLES } from "./polygonStyles";

/**
 * Entry point for polygon-related map utilities.
 * - this file: static polygon layers (real / simulated fire)
 * - polygonDraw.js: interactive drawing
 * - impactLayers.js: impact results (saved zone, saved / burned buildings)
 * Re-exported here so existing imports keep working.
 */
export { startPolygonDraw } from "./polygonDraw";
export {
  syncImpactLayers,
  setImpactLayersVisibility,
} from "./impactLayers";

export const syncPolygonLayer = (map, id, feature) => {
  const sourceId = `${id}-polygon`;
  const fillId = `${sourceId}-fill`;
  const lineId = `${sourceId}-line`;
  const style = STYLES[id];

  if (!feature) {
    [fillId, lineId].forEach((l) => map.getLayer(l) && map.removeLayer(l));
    if (map.getSource(sourceId)) map.removeSource(sourceId);
    return;
  }

  if (map.getSource(sourceId)) {
    map.getSource(sourceId).setData(feature);
    return;
  }

  map.addSource(sourceId, { type: "geojson", data: feature });

  map.addLayer({
    id: fillId,
    type: "fill",
    source: sourceId,
    paint: {
      "fill-color": style.fillColor,
      "fill-opacity": style.fillOpacity,
    },
  });

  map.addLayer({
    id: lineId,
    type: "line",
    source: sourceId,
    paint: {
      "line-color": style.lineColor,
      "line-width": style.lineWidth,
      ...(style.dasharray && { "line-dasharray": style.dasharray }),
    },
  });
};
export const setPolygonVisibility = (map, id, visible) => {
  [`${id}-polygon-fill`, `${id}-polygon-line`].forEach((l) => {
    if (map.getLayer(l)) {
      map.setLayoutProperty(l, "visibility", visible ? "visible" : "none");
    }
  });
};
